import { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { notification } from 'antd';

import * as EventService from '../../../services/bb-api/event';
import type { Event } from '../../../services/bb-api/event';
import { Spinner } from '../../shared/spinner';
import { txt } from '../../../locales/i18n';
import { EventForm } from './form';

export const EventPage = () => {
	const [event, setEvent] = useState<Event | null>(null);

	const history = useHistory();
	const params = useParams<{ id: string }>();
	const eventId = Number(params.id);

	const getEvent = useCallback(async () => {
		try {
			const event = await EventService.get(eventId);
			setEvent(event);
		} catch (error) {
			const message = (error as Error).name;
			const description = (error as Error).message;
			notification.error({ message, description });
			history.goBack();
		}
	}, [eventId, history]);

	useEffect(() => {
		getEvent();
	}, [getEvent]);

	const handleUpdateEvent = async (event: any) => {
		try {
			await EventService.update(eventId, event);
			history.goBack();

			const message = txt('notification.update successful');
			notification.success({ message });
		} catch (error) {
			const message = txt('notification.update failed');
			notification.error({ message });
		}
	};

	const handleRemoveEvent = async () => {
		await EventService.remove(eventId);
		history.replace('/events');
	};

	if (event === null) return <Spinner />;

	return (
		<Main>
			<EventForm
				initialValues={event}
				onSubmit={handleUpdateEvent}
				submitButtonText={txt('global.update')}
				onRemove={handleRemoveEvent}
			/>
		</Main>
	);
};

const Main = styled.main`
	display: flex;
	justify-content: center;
`;
